import React from 'react'
import {createIcon} from '@chakra-ui/react'

export const MarkUnreadMailboxIcon = createIcon({
  displayName: 'MarkUnreadMailboxIcon',
  viewBox: '0 0 14 14',
  path: (
    <path
      d="M11.667 4.08331H5.83366V5.24998H11.667V12.25H2.33366V5.24998H3.50033V7.58331H4.66699V2.91665H8.16699V0.583313H3.50033V4.08331H2.33366C1.69199 4.08331 1.16699 4.60831 1.16699 5.24998V12.25C1.16699 12.8916 1.69199 13.4166 2.33366 13.4166H11.667C12.3087 13.4166 12.8337 12.8916 12.8337 12.25V5.24998C12.8337 4.60831 12.3087 4.08331 11.667 4.08331Z"
      fill="currentColor"
    />
  ),
})
